var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"primary","size":"large","ghost":"","disabled":_vm.enumeratorDisabled,"loading":_vm.downloading},on:{"click":_vm.downloadReport}},[_vm._v(" "+_vm._s(_vm.$t('components.labels.standardizationTestReport'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }